"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = timeoutMs => new Promise(resolve => setTimeout(() => resolve(), timeoutMs));
exports.jsonLog = (label, obj) => console.log(JSON.stringify({ [label]: obj }, null, 2));
__export(require("./proms"));
__export(require("./execution-context"));
__export(require("./FileLineWriter"));
__export(require("./csv"));
__export(require("./ModelIterator"));
__export(require("./date/wsMoment"));
__export(require("./decorators"));
//# sourceMappingURL=index.js.map